import type { Observable } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type { UserTag } from '@domain/models/user.model';

export abstract class UserTagRepository {
  abstract list(query: PageQuery): Observable<PagedResult<UserTag>>;

  abstract create(name: string, isDefault: boolean): Observable<number>;

  abstract update(id: number, name: string, isDefault: boolean): Observable<void>;
}
